import styled from "styled-components";

export const HomeWrapper = styled("div")(() => {
    return {

    }
})